import { Component, Injector, OnInit, ViewChild, AfterViewInit, Input, QueryList, ViewChildren } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { RWidgetFormRenderBase } from '../r-widget-form-render-base';
import { IComponentDef } from '../../../shared/interfaces';

@Component({
  selector: '[r-widget-form-render],r-widget-form-render',
  templateUrl: './r-widget-form-render.component.html',
  styles: [],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class RWidgetFormRenderComponent {
  /** 页面表单 */
  constructor() {}

  /** 父级组件 */
  @Input() parentComponent: IComponentDef;

  /** 要渲染的组件 */
  @Input() component: IComponentDef;

  /** disabled */
  @Input() disabled: boolean = false;

  /** 是否显示按钮 */
  @Input() showButton: boolean = true;

  /** 是否显示边框 */
  // @Input() bordered: boolean = false;

  getLabelWidth(item: IComponentDef): string {
    if (typeof item.labelWidth !== 'number') {
      item.labelWidth = 100;
    }

    return `${item.labelWidth}px`;
  }
}
